document.addEventListener("DOMContentLoaded", function () {
  const sliderSections = document.querySelectorAll(".enable-slider-image-banner-list");

  sliderSections.forEach(function (sliderWrapper) {
    const sectionId = sliderWrapper.getAttribute("data-section-id");
    const slider = sliderWrapper.querySelector(`#SliderImages-${sectionId}`);
    const thumb = sliderWrapper.querySelector(`#scrollThumbImages-${sectionId}`);
    const rightGap = 0;

    const slides = sliderWrapper.querySelectorAll(".image-banner-container");
    const nextBtn = sliderWrapper.querySelector(".image-banner-list-next");
    const prevBtn = sliderWrapper.querySelector(".image-banner-list-prev");
    if (!slider || slides.length === 0 || !nextBtn || !prevBtn) return;

    let currentIndex = 0;
    let itemWidth = 0;
    let gap = 0;
    let step = 0;
    let visibleItems = 2;
    const totalItems = slides.length;

    function updateThumb() {
      const visibleWidth = slider.clientWidth;
      const totalScrollWidth = slider.scrollWidth;
      const scrollLeft = slider.scrollLeft;
      const scrollbar = thumb.parentElement;
      const scrollbarWidth = scrollbar.clientWidth - rightGap;

      const thumbWidth = (visibleWidth / totalScrollWidth) * scrollbarWidth;
      thumb.style.width = `${Math.max(30, thumbWidth)}px`;

      const maxScrollLeft = totalScrollWidth - visibleWidth;
      const maxThumbLeft = scrollbarWidth - thumb.offsetWidth;
      const thumbLeft = maxScrollLeft > 0 ? (scrollLeft / maxScrollLeft) * maxThumbLeft : 0;
      thumb.style.transform = `translateX(${thumbLeft}px)`;

      // Update currentIndex based on scroll position
      currentIndex = Math.round(scrollLeft / step);

      updateButtonState();
    }

    function updateButtonState() {
      const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
      const scrollLeft = slider.scrollLeft;

      prevBtn.disabled = scrollLeft <= 0;
      nextBtn.disabled = scrollLeft >= maxScrollLeft - 1;
    }

    slider.addEventListener("scroll", updateThumb);
    window.addEventListener("resize", () => {
      calculateStep();
      updateThumb();
    });
    updateThumb();

    let isDragging = false;
    let startX;
    let startScrollLeft;
    const scrollbar = thumb.parentElement;

    // Desktop drag
    thumb.addEventListener("mousedown", (e) => {
      isDragging = true;
      startX = e.pageX;
      startScrollLeft = slider.scrollLeft;
      document.body.classList.add("no-select");
      e.preventDefault();
    });

    document.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
      const deltaX = e.pageX - startX;
      handleDrag(deltaX);
    });

    document.addEventListener("mouseup", () => {
      isDragging = false;
      document.body.classList.remove("no-select");
    });

    // Mobile drag
    thumb.addEventListener("touchstart", (e) => {
      isDragging = true;
      startX = e.touches[0].pageX;
      startScrollLeft = slider.scrollLeft;
      document.body.classList.add("no-select");
    });

    document.addEventListener("touchmove", (e) => {
      if (!isDragging) return;
      const deltaX = e.touches[0].pageX - startX;
      handleDrag(deltaX);
    });

    document.addEventListener("touchend", () => {
      isDragging = false;
      document.body.classList.remove("no-select");
    });

    function handleDrag(deltaX) {
      const visibleWidth = slider.clientWidth;
      const totalScrollWidth = slider.scrollWidth;
      const scrollbarWidth = scrollbar.clientWidth - rightGap;
      const maxScrollLeft = totalScrollWidth - visibleWidth;
      const maxThumbLeft = scrollbarWidth - thumb.offsetWidth;

      const scrollRatio = maxScrollLeft / maxThumbLeft;
      slider.scrollLeft = startScrollLeft + deltaX * scrollRatio;
    }

    function calculateStep() {
      itemWidth = slides[0].offsetWidth;
      gap = window.innerWidth <= 749 ? 5 : 20;
      step = itemWidth + gap;

      const maxIndex = Math.max(0, totalItems - visibleItems);
      if (currentIndex > maxIndex) {
        currentIndex = maxIndex;
      }

      updateSliderPosition();
    }

    function updateSliderPosition() {
      const scrollX = step * currentIndex;
      slider.scrollTo({
        left: scrollX,
        behavior: 'smooth'
      });

      updateButtonState();
    }

    nextBtn.addEventListener("click", () => {
      if (currentIndex < totalItems - visibleItems) {
        currentIndex++;
        updateSliderPosition();
      }
    });

    prevBtn.addEventListener("click", () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateSliderPosition();
      }
    });
    requestAnimationFrame(() => {
      calculateStep();
      updateThumb();
    });
  });
});